module.exports = __webpack_public_path__ + "static/media/macbook_air.20353500.png";